import { COMMON_FORM_FIELD_NAMES } from 'features/common/forms/constants';

export const CAMPAIGN_MANAGEMENT_SIDEBAR_FORM_NAME = 'campaignManagementSidebar-filter';

const { channel, region, agency, manager, seller, ppz } = COMMON_FORM_FIELD_NAMES;

export const FIELDS = {
	printMode: 'printMode',
	automaticAssign: 'automaticAssign',
	channel,
	region,
	agency,
	manager,
	seller,
	ppz,
};

export default () => ({
	[FIELDS.printMode]: {
		deepPath: [FIELDS.printMode],
		validations: [],
	},
	[FIELDS.automaticAssign]: {
		deepPath: [FIELDS.automaticAssign],
		validations: [],
	},
	[FIELDS.channel]: {
		deepPath: [FIELDS.channel],
		validations: [],
	},
	[FIELDS.region]: {
		deepPath: [FIELDS.region],
		validations: [],
	},
	[FIELDS.agency]: {
		deepPath: [FIELDS.agency],
		validations: [],
	},
	[FIELDS.manager]: {
		deepPath: [FIELDS.manager],
		validations: [],
	},
	[FIELDS.seller]: {
		deepPath: [FIELDS.seller],
		validations: [],
	},
	[FIELDS.ppz]: {
		deepPath: [FIELDS.ppz],
		validations: [],
	},
});
